<template>
  <div>
    <div>
      <!-- onClickUploadButton -->
      <v-btn
        color="grey"
        :disabled="delayImport"
        :loading="loading"
        outline
        @click="showdialog = true"
      >
        <em class="fas fa-file-import" />
        &nbsp;
        {{ $t('import') }}
      </v-btn>
      <input
        :id="'csvUpload'"
        :key="keyupdate"
        v-validate="'mimes:text/xlsx'"
        type="file"
        class="form-control-file pt-2"
        name="csvUpload"
        data-vv-as="File"
        accept=".xlsx"
        style="overflow: hidden; position: fixed; width: 1px; height: 1px; z-index: -1; opacity: 0"
        @input="onFileChange($event)"
      />
    </div>
    <div>
      <v-btn color="grey" :loading="loading" outline @click="exportTemplate">
        <em class="fas fa-file-export" />
        &nbsp;
        {{ $t('export shop template') }}
      </v-btn>
    </div>
    <v-dialog v-model="showdialog" persistent width="600px">
      <v-card>
        <div class="pa-3">
          <div class="form-control" :class="{ 'has-error': errors.has('categoryname') }">
            <div>Category name</div>
            <input
              v-model="input.categoryname"
              v-validate="'required'"
              :data-vv-as="'Category'"
              name="categoryname"
              type="text"
              placeholder="กรอกชื่อ Category"
            />
            <span v-if="errors.has('categoryname')" class="text-error">{{
              errors.first('categoryname')
            }}</span>
          </div>
          <div>Start date</div>
          <v-layout row wrap class="ma-0" no-gutter>
            <v-flex xs6 class="mb-2">
              <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                <DatePickerWithoutButton
                  v-model="input.date.start"
                  name="startdate"
                  :data-vv-as="'Start date'"
                >
                  <v-text-field
                    class="custom-datepicker-input"
                    outline
                    :value="startdate"
                    readonly
                    type="text"
                    placeholder="DD/MM/YYYY"
                    hide-details
                  ></v-text-field>
                </DatePickerWithoutButton>
                <span v-if="errors.has('startdate')" class="text-error">{{
                  errors.first('startdate')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs3 class="pl-2 mb-2">
              <div class="form-control" :class="{ 'has-error': errors.has('starttime') }">
                <CustomTimepicker
                  name="starttime"
                  :data-vv-as="'Start time'"
                  :value="input.time.start"
                  overlay
                  format="HH:mm"
                  placeholder="HH:mm"
                  only-time
                  :minute-interval="10"
                  @onChange="
                    (val) => {
                      input.time.start = val
                    }
                  "
                >
                </CustomTimepicker>
                <span v-if="errors.has('starttime')" class="text-error">{{
                  errors.first('starttime')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
          <div>End date</div>
          <v-layout row wrap class="ma-0" no-gutter>
            <v-flex xs6>
              <div class="form-control" :class="{ 'has-error': errors.has('enddate') }">
                <DatePickerWithoutButton
                  v-model="input.date.end"
                  name="enddate"
                  :data-vv-as="'End date'"
                >
                  <v-text-field
                    class="custom-datepicker-input"
                    outline
                    :value="enddate"
                    readonly
                    type="text"
                    placeholder="DD/MM/YYYY"
                  ></v-text-field>
                </DatePickerWithoutButton>
                <span v-if="errors.has('enddate')" class="text-error">{{
                  errors.first('enddate')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <div class="form-control" :class="{ 'has-error': errors.has('endtime') }">
                <CustomTimepicker
                  v-validate="input.date.end ? 'required' : ''"
                  name="endtime"
                  :data-vv-as="'End time'"
                  :value="input.time.end"
                  overlay
                  format="HH:mm"
                  placeholder="HH:mm"
                  only-time
                  :minute-interval="10"
                  @onChange="
                    (val) => {
                      input.time.end = val
                    }
                  "
                >
                </CustomTimepicker>
                <span v-if="errors.has('endtime')" class="text-error">{{
                  errors.first('endtime')
                }}</span>
              </div>
            </v-flex>
          </v-layout>
          <div class="text-xs-center">
            <v-btn color="grey" outline @click="closedialog">{{ $t('ยกเลิก') }}</v-btn>
            <v-btn :loading="loading" color="primary" depressed @click="onClickUploadButton">{{
              $t('เลือกไฟล์')
            }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import parser from 'simple-excel-to-json'
import * as XLSX from 'xlsx'
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton'
import CustomTimepicker from '@/components/elements/CustomTimepicker2'
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    DatePickerWithoutButton,
    CustomTimepicker
  },
  data() {
    return {
      delayImport: false,
      loading: false,
      keyupdate: 1,
      showdialog: false,
      input: {
        categoryname: '',
        date: { start: '', end: '' },
        time: { start: '', end: '' }
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    startdate() {
      return this.input.date.start ? moment(this.input.date.start).format('DD/MM/YYYY') : ''
    },
    enddate() {
      return this.input.date.end ? moment(this.input.date.end).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    exportTemplate() {
      var json = [
        {
          keyword: '',
          image: '',
          name: '',
          sku: '',
          details: '',
          unit: '',
          price: '',
          discount_price: '',
          quantity: '',
          quantity_limit: ''
        }
      ]

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'template-importproduct.xlsx')
    },

    exportTemplate2: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      var csvdata =
        'keyword,image,name,sku,details,unit,price,discount_price,quantity,quantity_limit\r\n'

      //   this.filteredUser.forEach((el) => {
      //     csvdata += `${el.cardnumber ? el.cardnumber : '-'},${el.realname ? el.realname : '-'},${
      //       el.address ? el.address : '-'
      //     },${el.name ? el.name : '-'},${el.productname ? el.productname : '-'},${
      //       el.quantity ? el.quantity : '-'
      //     },${el.option ? el.option : '-'},${el.price ? el.price : '-'},${
      //       el.discountprice ? el.discountprice : '-'
      //     }\r\n`
      //   })
      vm.exportCsv(csvdata, 'template-importproduct')
    },

    closedialog() {
      this.input = {
        categoryname: '',
        date: { start: '', end: '' },
        time: { start: '', end: '' }
      }
      this.showdialog = false
    },
    async onClickUploadButton() {
      if (await this.$validator.validate()) {
        document.getElementById('csvUpload').click()
      }
    },
    onFileChange(event) {
      let vm = this
      vm.loading = true
      let files = event.target.files || event.dataTransfer.files
      var myFile = files[0]
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result)
        var workbook = XLSX.read(data, { type: 'array' })

        /* DO SOMETHING WITH workbook HERE */
        var result = []
        for (var sheet in workbook.Sheets) {
          result.push(vm.trimObj(XLSX.utils.sheet_to_json(workbook.Sheets[sheet])))
        }
        if (vm.selectedBot.theme == 'scgdistribution') {
          vm.uploadExcelScgdistribution(result)
        } else {
          vm.uploadExcel(result)
        }
      }
      reader.readAsArrayBuffer(myFile)
    },
    trimObj(obj) {
      var vm = this
      if (!Array.isArray(obj) && typeof obj != 'object') return obj
      return Object.keys(obj).reduce(
        function (acc, key) {
          acc[key.trim()] = typeof obj[key] == 'string' ? obj[key].trim() : vm.trimObj(obj[key])
          return acc
        },
        Array.isArray(obj) ? [] : {}
      )
    },
    uploadExcelScgdistribution(file) {
      var vm = this
      // var productlength = 0
      // file[1].map((el) => {
      //   var op1 = el.Option1Detail ? el.Option1Detail.split(',').length : 0
      //   var op2 = el.Option2Detail ? el.Option2Detail.split(',').length : 0
      //   if (op2) {
      //     productlength += op1 * op2
      //   } else productlength += op1
      // })
      if ((file[2] && file.length == 3) || true) {
        var data = {
          products: file,
          categoryname: this.input.categoryname,
          pageid: this.selectedBot.pageid,
          isCentral: [...this.$store.state.centralPage, '104716585038207', '362065616073'].includes(
            this.selectedBot.pageid
          )
        }
        var startdate = ''
        var enddate = ''
        if (this.input.date.start) {
          startdate = `${this.input.date.start} ${this.input.time.start + ':00'}`
          Object.assign(data, { starttime: startdate })
        }
        if (this.input.date.end) {
          enddate = `${this.input.date.end} ${this.input.time.end + ':00'}`
          Object.assign(data, { endtime: enddate })
        }
        api.scgdistributionimportproducts(data, (err, response) => {
          vm.loading = false
          vm.keyupdate++
          if (response.responsecode == 200) {
            vm.$swal
              .fire({
                type: 'success',
                text: 'นำเข้าสินค้าสำเร็จ'
              })
              .then(() => {
                window.location.reload()
              })
          } else {
            vm.$swal.fire({
              text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
            })
          }
        })
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    },
    uploadExcel(file) {
      var vm = this
      // var productlength = 0
      // file[1].map((el) => {
      //   var op1 = el.Option1Detail ? el.Option1Detail.split(',').length : 0
      //   var op2 = el.Option2Detail ? el.Option2Detail.split(',').length : 0
      //   if (op2) {
      //     productlength += op1 * op2
      //   } else productlength += op1
      // })
      if (file[2] && file.length == 3) {
        var data = {
          products: file,
          categoryname: this.input.categoryname,
          starttime: startdate,
          endtime: enddate,
          pageid: this.selectedBot.pageid,
          isCentral: [...this.$store.state.centralPage, '104716585038207', '362065616073'].includes(
            this.selectedBot.pageid
          )
        }
        api.postuploadproducts(data, (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            vm.$swal
              .fire({
                type: 'success',
                text: 'นำเข้าสินค้าสำเร็จ'
              })
              .then((result) => {
                window.location.reload()
              })
          } else {
            this.$swal.fire({
              text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
            })
          }
        })
      } else {
        this.$swal.fire({
          text: 'รูปแบบข้อมูลไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง'
        })
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ImportShopScgdistribution.vue